import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import {
  ArrowDownToDot,
  ArrowUpFromDot,
  CheckCheck,
  LibraryBig,
  MoreHorizontal,
  Plus,
} from "lucide-react";
import React from "react";
import { Link } from "react-router-dom";

const GetStarted = () => {
  return (
    <div className="flex flex-col items-center justify-center">
      <Card className="rounded-[0.6rem] " style={{ width: "258px" }}>
        <CardHeader>
          <Skeleton className="w-[20px] h-[20px] rounded-full relative mr-1">
            <Skeleton className="w-[8px] h-[8px] rounded-full bg-[#EFD948] absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" />
          </Skeleton>
          <Skeleton className="w-[20px] h-[20px] rounded-full relative">
            <Skeleton className="w-[8px] h-[8px] rounded-full bg-[#96EF48] absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" />
          </Skeleton>

          <CardTitle>
            <Skeleton className="w-[100px] h-[10px] rounded-lg ml-2 bg-[#FFFFFF]" />
          </CardTitle>
          <Button
            variant="icon"
            size="icon"
            className="rounded-lg bg-transparent ml-auto pointer-events-none"
          >
            <MoreHorizontal className="size-5" />
          </Button>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-2 gap-4">
            <div className="mt-1 flex flex-col justify-start mr-10">
              {/* <span className="text-xs text-gray-400"></span> */}
              <Skeleton className="w-[70px] h-[8px] rounded-lg bg-[#FFFFFF]" />
              {/* <PlatformBadge platform={"java"} /> */}
              <Skeleton className="mt-2 w-[44px] h-[20px] rounded-lg bg-[#991BF9] relative">
                <Skeleton className="w-[32px] h-[6px] rounded-lg bg-[#FFFFFF] absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" />
              </Skeleton>
            </div>

            <div className="mt-1 flex flex-col">
              <span className="text-xs text-gray-400">
                <Skeleton className="w-[100px] h-[8px] rounded-lg bg-[#FFFFFF]" />
              </span>
              <div className="flex items-center mt-2">
                <ArrowUpFromDot className="text-[#96EF48] w-[18px] h-[18px]" />
                <Skeleton className="w-[30px] h-[6px] rounded-lg bg-[#FFFFFF]" />

                <ArrowDownToDot className="text-[#EFD948] w-[18px] h-[18px] ml-4" />
                <Skeleton className="w-[30px] h-[6px] rounded-lg bg-[#FFFFFF]" />
              </div>
            </div>

            <div className="mt-1 flex flex-col justify-start mr-10">
              {/* <span className="text-xs text-gray-400"></span> */}
              <Skeleton className="w-[70px] h-[8px] rounded-lg bg-[#FFFFFF]" />
              {/* <PlatformBadge platform={"java"} /> */}
              <Skeleton className="mt-2 w-[40px] h-[8px] rounded-lg bg-[#FFFFFF] relative" />
            </div>

            <div className="mt-1 flex flex-col">
              <span className="text-xs text-gray-400">
                <Skeleton className="w-[100px] h-[8px] rounded-lg bg-[#FFFFFF]" />
              </span>
              <div className="flex items-center mt-2">
                <CheckCheck className="text-[#96EF48] w-[18px] h-[18px]" />
                <Skeleton className="ml-1 w-[56px] h-[6px] rounded-lg bg-[#FFFFFF]" />
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
      <div className="flex justify-center mt-4 flex-col max-w-[480px] ">
        <h3
          className="text-xl font-semibold text-white-500 tracking-[3px]"
          style={{ textAlign: "center" }}
        >
          Get started!
        </h3>
        <p
          className="text-sm text-gray-400 mt-2 font-medium tracking-[2px]"
          style={{ textAlign: "center" }}
        >
          Add a project and connect your first service to unlock clear,
          real-time system architecture visibility for everyone on your team.
        </p>
      </div>
      <div className="flex justify-center mt-4 gap-4">
        <a
          href="https://docs.vizops.io"
          target="_blank"
          rel="noopener noreferrer"
          className="ml-2"
        >
          <Button
            variant="secondary"
            className="w-auto h-[30px] tracking-[2px] bg-[#1A1C22]"
          >
            <LibraryBig className="w-15 h-15" />
            Go to Docs
          </Button>
        </a>

        <Link to="/projects?create=true">
          <Button variant="primary" className="w-auto h-[30px] tracking-[2px]">
            <Plus className="w-15 h-15" />
            Add Project
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default GetStarted;
